<script setup>
import Button from "@components/global/button.vue";
</script>

<template>
  <div
    class="w-full md:grid md:grid-cols-[50%_1fr_auto] md:items-center py-6 gap-4 border-t-2 border-b-2 border-dashed border-border-muted"
  >
    <div class="md:w-half w-full">
      <span
        class="w-full text-text-muted text-h3 md:text-h2 font-heading font-medium uppercase leading-[0.8]"
      >
        <slot name="title"></slot>
      </span>
    </div>
    <div class="text-body-sm uppercase md:block hidden">
      <slot name="text"></slot>
    </div>
    <div class="justify-self-end md:block hidden z-images">
      <slot name="button"></slot>
    </div>
  </div>
</template>

<style scoped></style>
